import IDs_WHISP from '../../constants/IdsWhisp';

/**
 * Function thatreturns the key name from the IDs_WHISP object, "ALTO", "BAJO", "MEDIO"
 * @param {number} riesgo
 * @returns {string} the key name from the IDs_WHISP object, "ALTO", "BAJO", "MEDIO"
 */
const getRiesgoEudrLabel = riesgo => Object.keys(IDs_WHISP).find(key => IDs_WHISP[key] === Number(riesgo));

export default getRiesgoEudrLabel;
